module.exports = __webpack_public_path__ + "5c23058703fd108ef168483e4bed0fbb.svg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/sponsors/tempo.svg
 ** module id = 381
 ** module chunks = 0
 **/